import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=131b0f5c&scoped=true"
import script from "./integration.vue?vue&type=script&lang=js"
export * from "./integration.vue?vue&type=script&lang=js"
import style0 from "./integration.vue?vue&type=style&index=0&id=131b0f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b0f5c",
  null
  
)

export default component.exports